import Vue from 'vue'
import Router from 'vue-router'
import { getToken } from '@/utils/auth'
Vue.use(Router)
// 公共路由
export const constantRoutes = [{
  path: '/',
  name: 'Home',
  component: () =>
    import('@/views/Home')
},
{
  path: `/home`,
  name: 'Home',
  component: () =>
    import('@/views/Home')
},
{
  path: '/login',
  name: 'Login',
  component: () =>
    import('@/views/Login')
},
{
  name: 'ChangePassword',
  path: '/changePassword',
  component: () =>
    import('@/views/userCenter/ChangePassword'),
  meta: {
    title: '修改密码',
    icon: '#'
  }
},
{
  name: 'UserCenter',
  path: '/userCenter',
  component: () =>
    import('@/views/userCenter/UserCenter'),
  meta: {
    title: '用户中心列表',
    icon: '#'
  }
}
]
const router = new Router({
  base: '/pdamain',
  mode: 'history', // 去掉url中的#
  routes: constantRoutes
})
// 解决路由重复报错
const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error)
}
// 路由守卫
const whiteList = [`/login`, '/register']
// 路由守卫
router.beforeEach((to, from, next) => {
  if (getToken()) {
    next()
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      next()
    } else {
      location.href = '/pdamain/login'
    }
  }
})

export default router
